import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Join.css'; // Assuming you have a CSS file for styling
    

const Join = () => {    
    const form =useRef();
    const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_w04a4cr', 'YOUR_TEMPLATE_ID', form.current, {
        publicKey: 'YOUR_PUBLIC_KEY',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };
  return (
    <div className="Join" id='Join-us'>
        <div className="left-j">
            <hr />
            <div>
                <span className='stroke-text'>Ready to</span>
                <span>Level up</span>
            </div>
            <div>
                <span>your body</span>
                <span className='stroke-text'>with us?</span>
            </div>
        </div>  
        <div className="right-j"> 
            <form ref={form} className='email-container' onSubmit={sendEmail}>
                <input type="email" name='user-email' placeholder='Enter your email address' />
                <button className='btn btn-j'>Join Now</button>
            </form>
        </div>       

    </div>
  );
}
export default Join;